import { DashboardModule } from '@domain-group/suit-theme'

import { useFilters } from '@domain-group/react-hooks'

import useProviderPackages from '@hooks/useProviderPackages'

import DashboardModuleFilters from '@components/DashboardModuleFilters'

import ProviderPackageListItem from './PackageListItem'

const buildPageFilterFields = () => {
  const style = {
    marginBottom: 16,
  }

  return [
    {
      component: 'DynamicInput',
      componentProps: {
        inputComponent: 'input',
        style,
      },
      key: 'string',
      label: 'Package Title or ID',
    },
  ]
}

interface PackagesProps {
  providerPriceListId: number,
}

const Packages = (props: PackagesProps) => {
  const { providerPriceListId } = props

  const filterPayload = useFilters()
  const {
    pageFilters,
  } = filterPayload

  const providerPackagesPayload = useProviderPackages({
    filters: {
      ...pageFilters,
      provider_price_list_id: providerPriceListId,
    },
    performHttpRequests: !!providerPriceListId,
    requestOptions: {
      include_provider_package_price_list_ids: true,
    },
  })

  const {
    callbacks: {
      loadMore,
    },
    canLoadMore,
    filteredProviderPackages,
    filteredProviderPackagesCount,
    hasFilteredProviderPackages,
    loading,
  } = providerPackagesPayload

  return (
    <DashboardModule
      contentBoxProps={{ flexDirection: 'column' }}
      headerRight={<DashboardModule.FilterHeader {...filterPayload} />}
      loading={loading}
      title="Packages"
    >
      <DashboardModuleFilters
        filterFields={buildPageFilterFields()}
        {...filterPayload}
      />

      {!loading && hasFilteredProviderPackages && (
        <DashboardModule.ScrollableSection>
          {filteredProviderPackages.map(providerPackage => (
            <ProviderPackageListItem
              key={providerPackage.id}
              providerPackage={providerPackage}
            />
          ))}
        </DashboardModule.ScrollableSection>
      )}

      {!loading && !hasFilteredProviderPackages && (
        <DashboardModule.BlankState>
          <DashboardModule.BlankState.Title>
            No Packages Present
          </DashboardModule.BlankState.Title>

          <DashboardModule.BlankState.Paragraph>
            Packages will appear here when package items are assigned to this Price List
          </DashboardModule.BlankState.Paragraph>
        </DashboardModule.BlankState>
      )}

      <DashboardModule.LoadMoreFooter
        boxProps={{ borderTop: loading ? 'none' : '1px solid' }}
        callbacks={{ loadMore }}
        canLoadMore={canLoadMore}
        entityCount={filteredProviderPackagesCount}
        loading={loading}
      />
    </DashboardModule>
  )
}

export default Packages
